import peepLogin from "./peepLogin";
import withLogin from "./withLogin";

export default {
  withLogin,
  peepLogin,
};
